<template>
    <div class="disease-science">
        <section
            v-for="item in sections"
            :id="item.id"
            :key="item.key"
            class="science-section"
        >
            <div class="section-head">
                <h3 class="section-tit">{{ item.title }}</h3>
            </div>
            <div class="section-body">
                <symptom-manifestation v-if="item.key === 'symptom'" />
                <nursing-care v-else-if="item.key === 'nursing'" />
            </div>
        </section>
    </div>
</template>

<script>
import SymptomManifestation from './comps/symptom_manifestation.vue';
import NursingCare from './comps/nursing_care.vue';

export default {
    name: 'DiseaseScience',
    components: {
        SymptomManifestation,
        NursingCare,
    },
    data() {
        return {
            sections: [
                { key: 'expert', id: 'expertKnowledge', title: '医家知识' },
                { key: 'symptom', id: 'symptomManifestation', title: '症状表现' },
                { key: 'nursing', id: 'nursingCare', title: '护理调养' },
            ],
        };
    },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
